<div class="container mt-0 flex-auto flex-col">
  <div class="sticky top-0 z-10  dark:bg-gray-900">

      <table class="w-full table-fixed mat-elevation-z" mat-table [dataSource]="dataSource" matSort
          (matSortChange)="changeSort($event)" matSortDisableClear multiTemplateDataRows>

          <ng-container matColumnDef="det">
              <th mat-header-cell *matHeaderCellDef class="no-padding-cell" style="min-width: 40px; width: 70px;"></th>
              <td mat-cell *matCellDef="let element" class="no-padding-cell">
                <button class="h-7 min-h-7 min-w-10 px-2 leading-6" 
                (click)="toggleDetails(element)" style="margin-left: 10px;">
                    <mat-icon class="icon-size-5"
                        [svgIcon]="selectedOrder?._id === element._id
                            ? 'heroicons_solid:chevron-up' : 'heroicons_solid:chevron-down' "></mat-icon>
                </button>
              </td>
          </ng-container>

          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef style="min-width: 40px; width: 70px;">
              <mat-checkbox color="primary" (change)="$event ? masterToggle() : null; validateIfJoinButtonIsShow()"
                  [checked]="selection.hasValue()"
                  [indeterminate]="selection.hasValue() && !isAllSelected()"
                  [aria-label]="checkboxLabel()">
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
              <mat-checkbox color="primary" (click)="$event.stopPropagation()"
                  (change)="$event ? selection.toggle(row) : null; validateIfJoinButtonIsShow()"
                  [checked]="selection.isSelected(row)"
                  [aria-label]="checkboxLabel(row)"
                  > <!--[disabled]="row.newBusinessPartnerFlag != statusEnum.APPROVED"-->
              </mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="serial">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">Pedido</th>
              <td mat-cell *matCellDef="let element" class=" text-left first-col table-text">
                <div class="table-text-m badge-center flex flex-col items-start" *ngIf="element.serial; else noData">
                  <div class="flex items-center gap-1">
                    <span>
                      <b [ngClass]="{ 'underline cursor-pointer': isThereOrderSourceTransaction(element) }"
                        (click)="isThereOrderSourceTransaction(element) && goToOrder(element)"
                        [matTooltip]="isThereOrderSourceTransaction(element) ? 'Ir al pedido' : ''">
                        {{ element?.serial ? element?.serial : '-' }} <mat-icon *ngIf="isThereOrderSourceTransaction(element)"
                          class="icon-size-3" [svgIcon]="'heroicons_solid:arrow-top-right-on-square'"
                          style="color:rgb(0, 0, 0);"></mat-icon>
                      </b>
                    </span>
                  
                    <div matTooltip="Pedido Unificado" matTooltipPosition="above">
                      <span
                      *ngIf="element?.sourceTransactions?.length >= 2"
                      matBadge="{{ element.sourceTransactions.length }}"
                      class="custom-badge"
                      matBadgeOverlap="false"
                      >
                      </span>
                    </div> 
                  </div>
                  
                  <div matTooltip="Fecha de Creación" class="f-10 mt-[-8px]">
                    FC: {{ element.createdAt | FormatDateHour: false }}
                  </div>
                </div>
              </td>
          </ng-container>

          <ng-container *ngIf="displayedColumns.includes('trip')" matColumnDef="trip">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">Viaje</th>
            <td mat-cell *matCellDef="let element" class=" text-left first-col table-text">
              <p class="table-text-m" style="min-width: 102px;">
                <span
                  class="text-secondary flex items-center px-3 cursor-pointer"
                  [ngClass]="{ 'underline': element?.trip?.id }"
                  (click)="element?.trip?.id && goToTravel(element)"
                  [matTooltip]="element?.trip.id ? 'Ir al viaje' : ''"
                >
                  <span>{{ element?.trip?.id ? element.trip.id : '-' }}</span>
                  <mat-icon
                    *ngIf="element?.trip.id"
                    class="ml-2 icon-size-3 hover:animate-bounce"
                    [svgIcon]="'heroicons_outline:rocket-launch'"
                    style="color:rgb(0, 0, 0);"
                  ></mat-icon>
                </span>
                <span class="f-10">
                  FI: <i>{{element.trip?.dateHourStart | FormatDateHour: false}}</i><br>
                  FF: <i>{{element.trip?.dateHourEnd | FormatDateHour: false}}</i><br>
                </span>
              </p>
            </td>
          </ng-container>

          <ng-container *ngIf="displayedColumns.includes('subRoute')" matColumnDef="subRoute">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">Ruta</th>
            <td mat-cell *matCellDef="let element" class=" text-left first-col table-text">
              <p class="table-text-m" *ngIf="element.subRoute; else noData">
                <span class="table-text-code">{{ element?.subRoute?.externalKeys?.code ?? element?.subRoute?.model }}</span><br>
                {{ element.subRoute?.name }}
              </p>
            </td>
          </ng-container>

          <ng-container matColumnDef="soldTo">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle">SN Pagador</th>
            <td mat-cell *matCellDef="let element" class="text-left first-col table-text">
              <p class="table-text-m" style="min-width: 102px;">
                <span class="table-text-code">{{element.soldTo?.externalKeys?.code}}</span><br>
                <span style="display: flex; align-items: center;">
                  @switch (element.shipToType) {
                    @case ('BPT9001') {
                      <span class="cursor-pointer" matTooltip="Consumidor Final">
                        <mat-icon style="color: #1976d2;">person_outline</mat-icon> 
                      </span>
                    }
                    @case ('BPT9002') {
                      <span class="cursor-pointer" matTooltip="Cliente Eventual">
                        <mat-icon style="color: #2e7d32;">person</mat-icon> 
                      </span>
                    }
                  }
                  {{ element.soldTo?.name }}
                </span>
              </p>
            </td>
          </ng-container>

          <ng-container matColumnDef="shipTo">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle">SN Receptor</th>
            <td mat-cell *matCellDef="let element" class="text-left first-col table-text">
              <p class="table-text-m" style="min-width: 102px;">
                <span class="table-text-code">{{element.shipTo?.externalKeys?.code}}</span><br>
                <span style="display: flex; align-items: center;">
                  @switch (element.shipToType) {
                    @case ('BPT9001') {
                      <span class="cursor-pointer" matTooltip="Consumidor Final">
                        <mat-icon style="color: #1976d2;">person_outline</mat-icon> 
                      </span>
                    }
                    @case ('BPT9002') {
                      <span class="cursor-pointer" matTooltip="Cliente Eventual">
                        <mat-icon style="color: #2e7d32;">person</mat-icon> 
                      </span>
                    }
                  }
                  {{ element.shipTo?.name }}
                </span>
              </p>
            </td>
          </ng-container>
        
          <ng-container matColumnDef="address">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle"
            style="min-width: 200px; width: 280px">Dirección</th>
            <td mat-cell *matCellDef="let element" class="text-left first-col table-text">
              <p class="table-text-m ellipsis"
                 [matTooltip]="element.address?.address + 
                               (element.address?.postalCode ? ' / ' + element.address?.postalCode : '') + 
                               (element.address?.contactName ? ' / ' + element.address?.contactName : '') + 
                               (element.address?.locationTwo?.name ? ' / ' + element.address?.locationTwo?.name : '') + 
                               (element.address?.LocationThree?.name ? ' / ' + element.address?.LocationThree?.name : '')"
                 matTooltipPosition="above">
                <span class="f-10">
                  {{ element.address?.address }} 
                  {{ element.address?.postalCode ? ' / ' + element.address?.postalCode : '' }} 
                  {{ element.address?.contactName ? ' / ' + element.address?.contactName : '' }} 
                  {{ element.address?.locationTwo?.name ? ' / ' + element.address?.locationTwo?.name : '' }} 
                  {{ element.address?.LocationThree?.name ? ' / ' + element.address?.LocationThree?.name : '' }}
                </span>
              </p>
            </td>            
          </ng-container>

          <ng-container matColumnDef="weight">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle text-right">
                <span class="table-text-m-2">Carga</span>
              </th>
              <td mat-cell *matCellDef="let element" class=" text-left first-col table-text ">
                <p class="table-text-m-2">
                  {{ (element?.weight ?? 23.3 | weightFormat:'lbs') }}
                </p>
              </td>
          </ng-container>

          <ng-container *ngIf="displayedColumns.includes('deliveryDateTime')" matColumnDef="deliveryDateTime">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">Carga y <br> Entrega</th>
              <td mat-cell *matCellDef="let element" class=" text-left first-col table-text">
                  <b>C:</b> {{element?.loadDateTime | FormatDateHour: true}}<br>
                  <b>E:</b> {{element?.deliveryDateTime | FormatDateHour: true}}
              </td>
          </ng-container>

          <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef class=" text-right first-col" style="min-width: 40px; width: 70px">  
                <button *ngIf="selection.selected.length > 0 " mat-icon-button [matMenuTriggerFor]="actionOrder" matTooltip="Acciones">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #actionOrder="matMenu">
                  <button mat-menu-item (click)="validateEditOrderModal()">
                    <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                    <span>Mover</span>
                  </button>
                  <button *ngIf="canJoin" mat-menu-item (click)="openMConfirmDialog()" [disabled]="isNoOrderSelectionJoin">
                    <mat-icon svgIcon="heroicons_outline:squares-plus"></mat-icon>
                    <span>Unificar</span>
                  </button>
                  <button *ngIf="canCancel" mat-menu-item (click)="orderSelectionType = OrderSelectionType.MULTIPLE; showCancelOrderModal()">
                    <mat-icon svgIcon="delete"></mat-icon>
                    <span>Anular</span>
                  </button>
                </mat-menu>
              </th>

              <td mat-cell *matCellDef="let element" class=" text-right first-col">
                <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #actionMenu="matMenu">
                  <button mat-menu-item *ngIf="element?.statusId != 0 && element?.statusId != 7 && element?.statusId != 8" 
                    (click)="orderSelectionType = OrderSelectionType.SINGLE; showEditOrderModal(element)">
                    <mat-icon
                      svgIcon="heroicons_outline:pencil-square"
                    ></mat-icon>
                    <span>Mover</span>
                  </button>
                  <button mat-menu-item *ngIf="canCancel"
                    (click)="orderSelectionType = OrderSelectionType.SINGLE; showCancelOrderModal(element)">
                    <mat-icon
                      svgIcon="delete"
                    ></mat-icon>
                    <span>Anular</span>
                  </button>
                      <button mat-menu-item  *ngIf="element.operationType === 4"
                    (click)="orderSelectionType = OrderSelectionType.SINGLE; disunifyOrderModal(element)">
                    <mat-icon
                      svgIcon="heroicons_outline:document-duplicate"
                    ></mat-icon>
                    <span>Desunificar</span>
                  </button>
                  <button mat-menu-item *ngIf="pendingModalOpen == false"
                    (click)="showPendingOrdersByUser(element, 'soldTo')">
                    <mat-icon
                      svgIcon="hourglass_empty"
                    ></mat-icon>
                    <span>Pendientes Pagador</span>
                  </button>
                  <button mat-menu-item *ngIf="pendingModalOpen == false"
                    (click)="showPendingOrdersByUser(element, 'shipTo')">
                    <mat-icon
                      svgIcon="hourglass_empty"
                    ></mat-icon>
                    <span>Pendientes Receptor</span>
                  </button>
                </mat-menu>
              </td>
          </ng-container>                

          <ng-container matColumnDef="expandedDetail">
              <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
              <tr *ngIf="selectedOrder?._id === element._id" class="details-row">
                  <td [attr.colspan]="displayedColumns.length">
                      <ng-container *ngTemplateOutlet="rowDetailsTemplate; context: { $implicit: row }"></ng-container>
                  </td>
              </tr>
          </ng-container>

          <!-- Header Row -->
          <tr mat-header-row *matHeaderRowDef="displayedColumns" class="sticky top-0 z-10  bg-white shadow-md shadow-gray-700/10 dark:bg-gray-900"></tr>
          <!-- Fila principal -->
          <tr id="datarow" mat-row *matRowDef="let element; columns: displayedColumns;" class="border-b "
          [ngClass]="{
            'bg-gray-100 hover:bg-gray-100 border-b-2 border-gray-100 mdc-data-table__row--selected' : selectedOrder?._id === element._id,
          }"
          [class.table-expanded-row]="selectedOrder?._id === element._id"></tr>
          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="table-detail-row"></tr>
      </table>
  </div>
  <div *ngIf="this.dataSource.data.length === 0" class="border-t p-8 text-center text-1xl sm:p-10">Lo sentimos, no hay registros para mostrar.
  </div>
</div>



<ng-template #rowDetailsTemplate let-order>
  <div class="overflow-hidden" >

    <app-order-details-table [detailData]="selectedOrder.detail" [UMPActive]="UMPActive"
    ></app-order-details-table>
      
  </div>
</ng-template>

<ng-template #noData>
<span>
  -
</span>
</ng-template>

<!-- Modal Editar -->
<ng-template #editModal>
  <h2 mat-dialog-title class="text-lg font-bold mb-1">Mover Pedido</h2>
  <small></small>
  <mat-dialog-content class="modal-content">

    <form [formGroup]="editOrderForm">
      <div class="grid grid-cols-2 gap-x-4">
        <mat-form-field appearance="fill" class="w-full">
          <mat-label class="block text-gray-700">Oficina de Venta</mat-label>
          <mat-select formControlName="salesOffice" name="salesOffice" (selectionChange)="changeSearchRoute()">
            <mat-option>
              <ngx-mat-select-search [(ngModel)]="searchOffice" [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="changueOptionsSalesOffice($event)" placeholderLabel="Buscar oficina..."
                  noEntriesFoundLabel="No se encontraron resultados">
              </ngx-mat-select-search>
            </mat-option>
            @for (office of listFilterSalesOfficeList(); track office) {
            <mat-option [value]="office._id">
                <b *ngIf="getCode(office) as code">{{ code }} - </b>{{ office.name }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill" class="w-full">
          <mat-label class="block text-gray-700">Grupo de Rutas</mat-label>
          <mat-select formControlName="routeGroup" (selectionChange)="changeSearchRoute()">
            <mat-option *ngFor="let routes of routeGroup()" [value]="routes._id">{{routes.name}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill" class="w-full">
          <mat-label class="block text-gray-700">Ruta</mat-label>
          <mat-select formControlName="route" (selectionChange)="fetchTrip()">
            <mat-option>
              <ngx-mat-select-search [(ngModel)]="searchRoute" [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="changueOptionsRoute($event)" placeholderLabel="Buscar ruta..."
                  noEntriesFoundLabel="No se encontraron resultados">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let route of listFilterRoutesList()" [value]="route._id">{{route.name}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill" class="w-full">
                <mat-label class="block text-gray-700">Viaje</mat-label>
                <mat-select formControlName="trip" (selectionChange)="cleanDeliveryDate(); changeTrip();">
                <mat-option *ngFor="let trip of trips()" [value]="trip._id">
                    {{trip.id}}
                    <span class="f-10">
                    <i>( Desde: {{trip?.dateHourStartTeoric | FormatDateHour: false}} Hasta {{trip?.dateHourEndTeoric | FormatDateHour: false }} )</i>
                    <strong class="ml-2" [ngClass]="{
                            'text-blue-500': trip?.statusTripId === 2,
                            'text-amber-500': trip?.statusTripId === 4,
                            'text-green-500': trip?.statusTripId === 3
                        }">
                        [{{ getTripStatusLabel(trip?.statusTripId) }}]
                    </strong>
                    </span>
                </mat-option>
                </mat-select>
                <mat-hint *ngIf="trips() && trips().length === 0">No se encontro viajes</mat-hint>
            </mat-form-field>
            
        <!-- <mat-form-field appearance="fill" class="w-full">
          <mat-label class="block text-gray-700">Viaje</mat-label>
          <mat-select formControlName="trip" (selectionChange)="cleanDeliveryDate(); changeTrip();">
            <mat-option *ngFor="let trip of trips()" [value]="trip._id">
              {{trip.id}}
              <span class="f-10">
                <i>( Desde: {{trip?.dateHourStartTeoric | FormatDateHour: false}} Hasta {{trip?.dateHourEndTeoric | FormatDateHour: false }} )</i>
              </span>
            </mat-option>
          </mat-select>
          <mat-hint *ngIf="trips() && trips().length === 0">No se encontro viajes</mat-hint>
        </mat-form-field> -->
        
      </div>
      <div class="flex flex-row gap-2">
        <mat-form-field class="w-full">
          <mat-label>Fecha y Hora de Entrega</mat-label>
          <input matInput [matDatepicker]="dateDe" formControlName="dateDelivery" [min]="minDate" [max]="maxDate">
          <mat-datepicker-toggle matIconSuffix [for]="dateDe"></mat-datepicker-toggle>
          <mat-datepicker #dateDe></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="fill" class="w-full">
          <mat-label></mat-label>
          <mat-icon matSuffix>schedule</mat-icon>
          <input matInput formControlName="timeDelivery"
            name="timeDelivery" placeholder="Inicio" [min]="minTime"
            [ngxTimepicker]="default2"
          />
          <ngx-material-timepicker #default2></ngx-material-timepicker>
        </mat-form-field>
      </div>
      
      <div *ngIf="this.editOrderForm.value.trip" class="w-full">
        <span class="block text-gray-700">Fecha de Carga </span>
        {{this.editOrderForm.value.dateLoad | FormatDateHour: false}} {{this.editOrderForm.value.timeLoad}} 
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions class="modal-actions flex">
    <button mat-button mat-dialog-close class="align-left">Cancelar</button>
    <button mat-raised-button color="primary" class="justify-end"
    (click)="updateOrder(selectedOrder)" [disabled]="isOtherRoute"
    >Guardar</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #confirmDialog let-data>
  <div class="flex items-start space-x-2 mb-4">
    <div class="flex items-center">
      <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6" style="font-size: 32px"></mat-icon>
    </div>
    <div class="grid">
      <h2 mat-dialog-title class="text-lg font-bold mb-1">
        {{data.title}}
      </h2>
      <mat-dialog-content class="modal-content mt-0">
        <p *ngIf="data.message">{{data.message}}</p>
        <div *ngIf="data.innerHTML" [innerHTML]="data.innerHTML"></div>
      </mat-dialog-content>
    </div>
  </div>
  <mat-dialog-actions class="modal-actions flex justify-end">
    <button mat-button mat-dialog-close class="align-left">
        Conservar
    </button>
    <button mat-raised-button color="warn" [mat-dialog-close]="true">
        Aceptar
    </button>
  </mat-dialog-actions>
</ng-template>

<ng-template #confirmBpDialog let-data>
  <div class="p-4 max-w-md">
    <div class="flex items-start space-x-4">
      <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500" style="font-size: 36px"></mat-icon>
      <div>
        <h2 class="text-lg font-semibold text-gray-800">Cliente con Ruta Incorrecta</h2>
        <p class="text-sm text-gray-600">Los siguientes clientes no pertenecen a la ruta seleccionada:</p>

        <!-- Contenedor con scroll si hay muchas órdenes -->
        <div class="max-h-60 overflow-y-auto mt-2">
          <ul class="text-sm text-gray-700 list-disc pl-5">
            <li *ngFor="let order of data.invalidOrders">
              {{ order.shipToName }} <span class="font-semibold">(Pedido: {{ order.serial }})</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="flex justify-end mt-4">
      <button mat-raised-button color="primary" [mat-dialog-close]="true">Aceptar</button>
    </div>
  </div>
</ng-template>

<ng-template #pendingOrderByUserModal>
  <h2 mat-dialog-title class="text-lg font-bold mb-1">Pedidos pendientes - {{pendingUserName}}</h2>
  <small></small>
  <mat-dialog-content class="modal-content">
    <app-order-table [ordersData]="pendingOrders" (onSortChange)="changeSort($event)"
      [displayedColumns]="(['det', 'select', 'serial','trip', 'subRoute', 'soldTo', 'shipTo', 'address', 'deliveryDateTime', 'weight', 'actions'])" 
      [loadCalculationMode]="loadCalculationMode"
      [UMPActive]="UMPActive"
      [canJoin]="false"
      [pendingModalOpen]="true"
      [pendingUserName]="pendingUserName"

    >
    </app-order-table>
  </mat-dialog-content>
  <mat-dialog-actions class="modal-actions flex justify-end">
    <button mat-raised-button color="warn" [mat-dialog-close]="true">
        Aceptar
    </button>
  </mat-dialog-actions>
</ng-template>